import { useQuery } from "@tanstack/react-query";
import { BuildingStorefrontIcon } from "components/Icons";

import Divider from "components/MeForm/Divider";
import proxy from "api/proxy";

function Shops({ section, record, onClick }) {
  const shops = useQuery({
    queryKey: ["shops"],
    queryFn: async () => {
      const { data } = await proxy.search(
        "sale.shop",
        [],
        [
          "name",
          "address.street",
          "product_categories.childs",
          "party.name",
          "company",
          "pos_authorization",
          "electronic_authorization",
          "manual_authorization",
        ],
      );
      return data ?? [];
    },
  });

  let selected = record?.id ?? "";

  function handleClick(value) {
    selected = value.id;
    onClick(section, value);
  }

  return (
    <div className="mt-3" id={section}>
      <Divider text={`sale_call_center.${section}`} key={section} />
      <div className="grid grid-cols-2 md:grid-cols-4 tablet:grid tablet:grid-cols-3 gap-5 mb-4">
        {shops.data?.map((shop) => {
          return (
            <div
              className={
                "flex cursor-pointer shadow-sm justify-center items-center hover:opacity-50 py-6 rounded-md px-4 " +
                (shop.id !== selected ? "bg-green-100" : "bg-green-300")
              }
              key={shop.id}
              onClick={() => handleClick(shop)}
            >
              <BuildingStorefrontIcon className="w-6 h-6 mr-4 fill-gray-600 " />
              <div>
                <p className="pointer-events-none text-gray-900 text-lg">
                  {shop.name}
                </p>
                <p className="pointer-events-none text-gray-600 text-sm">
                  {shop["address."]?.street}
                </p>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
export default Shops;
